import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-si-download-software',
  templateUrl: './si-download-software.component.html',
  styleUrls: ['./si-download-software.component.scss']
})
export class SiDownloadSoftwareComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
